<div class="layout-column tr fade-element-in-only" 
     [ngClass]="{'selected': isSelected}"
     (mouseenter)="isHovered = true"
     (mouseleave)="isHovered = false">

  <div class="flex layout-row layout-align-start-center">
    <div class="td flex large layout-row layout-align-start-center position-relative">
      <bringoz-button *ngIf="job.routed && (job.lockedToRoute || isHovered)"
                      type="tertiary"
                      size="fit"
                      class="locked-to-route-icon"
                      [ngbTooltip]="(job.lockedToRoute ? 'Unlock from Route' : 'Lock to Route') | translate"
                      container="body"
                      openDelay="300"
                      (onClick)="onToggleLock(); $event.stopPropagation()">
        <bringoz-icon [iconName]="job.lockedToRoute ? 'lock' : 'lock-open-outline'" classSize="md" fill="#484848"></bringoz-icon>
      </bringoz-button>
      <app-bringoz-checkbox [isChecked]="isSelected"
                            (clickEvent)="onToggleSelected()">

      </app-bringoz-checkbox>
      <div class="drag-wrapper">
        <ng-content></ng-content>
      </div>
      <span class="job"
            [ngClass]="job.routed ? 'routed': 'left-over'">{{ programTypeAliasMap[job.pricePlanProgramType] }}</span>
      <span class="br-body-1 font-weight-400 text-ellipsis margin-left-5"
            [ngbTooltip]="accountTooltipTmpl"
            openDelay="300"
            triggers="hover"
            container="body">{{ job.accountName }}</span>
      <ng-template #accountTooltipTmpl>
        <div class="layout-column layout-align-start-start">
          <span>{{ job.accountName }}</span>

          <span *ngIf="job.jobType === serviceTypes.Delivery"
                class="text-ellipsis">{{ job.stops[1].address | bringozAddress }}</span>
          <span *ngIf="job.jobType === serviceTypes.Operation"
                class="text-ellipsis">{{ job.stops[0].address | bringozAddress }}</span>
        </div>
      </ng-template>

    </div>

    <div class="td flex-10 layout-row layout-align-center-center">
      <span *ngIf="job.deliveryDay" class="delivery pointer"
            [ngbTooltip]="deliveryTooltipTmpl"
            openDelay="300"
            container="body"
            triggers="hover">
        D
        <ng-template #deliveryTooltipTmpl>
          <div class="layout-column">
            <div class="layout-row layout-align-start-center">
              <bringoz-icon iconName="etd" classSize="xl" class="gray-101"></bringoz-icon>
              <span class="margin-left-5">{{ {etd: job?.deliveryEtd} | bringozTime: 'etd' }}</span>
            </div>
          </div>
        </ng-template>
      </span>
    </div>

<!--    <div class="td flex large layout-row layout-align-start-center"-->
<!--         [ngbTooltip]="addressTooltipTmpl"-->
<!--         openDelay="300"-->
<!--         triggers="hover"-->
<!--         container="body">-->
<!--      <span *ngIf="job.jobType === serviceTypes.Delivery"-->
<!--            class="br-body-1 font-weight-400 text-ellipsis">{{ job.stops[1].address | bringozAddress }}</span>-->
<!--      <span *ngIf="job.jobType === serviceTypes.Operation"-->
<!--            class="br-body-1 font-weight-400 text-ellipsis">{{ job.stops[0].address | bringozAddress }}</span>-->
<!--      <ng-template #addressTooltipTmpl>-->
<!--        <span *ngIf="job.jobType === serviceTypes.Delivery"-->
<!--              class="text-ellipsis">{{ job.stops[1].address | bringozAddress }}</span>-->
<!--        <span *ngIf="job.jobType === serviceTypes.Operation"-->
<!--              class="text-ellipsis">{{ job.stops[0].address | bringozAddress }}</span>-->
<!--      </ng-template>-->
<!--    </div>-->

    <div class="td flex large layout-row layout-align-start-center"
         [ngbTooltip]="timeWindowTooltipTmpl"
         openDelay="300"
         triggers="hover"
         container="body">
      <span *ngIf="job.jobType === serviceTypes.Delivery"
            class="br-body-1 font-weight-400 text-ellipsis">{{ job.stops[1] | timeWindow }}</span>
      <span *ngIf="job.jobType === serviceTypes.Operation"
            class="br-body-1 font-weight-400 text-ellipsis">{{ job.stops[0] | timeWindow }}</span>
      <ng-template #timeWindowTooltipTmpl>
        <span *ngIf="job.jobType === serviceTypes.Delivery"
              class="text-ellipsis">{{ job.stops[1] | timeWindow }}</span>
        <span *ngIf="job.jobType === serviceTypes.Operation"
              class="text-ellipsis">{{ job.stops[0] | timeWindow }}</span>
      </ng-template>
    </div>

    <div class="td flex-20 large layout-row layout-align-start-center">
   <span *ngIf="job.jobType === serviceTypes.Delivery"
         class="br-body-1 font-weight-400 text-ellipsis">{{ job.stops[1].detailedServiceTime.generatedTotalTime | bringozTimeConvert: true }}</span>
      <span *ngIf="job.jobType === serviceTypes.Operation"
            class="br-body-1 font-weight-400 text-ellipsis">{{ job.stops[0].detailedServiceTime.generatedTotalTime | bringozTimeConvert: true }}</span>
      <ng-template #timeWindowTooltipTmpl>
        <span *ngIf="job.jobType === serviceTypes.Delivery"
              class="text-ellipsis">{{ job.stops[1].detailedServiceTime.generatedTotalTime | bringozTimeConvert: true }}</span>
        <span *ngIf="job.jobType === serviceTypes.Operation"
              class="text-ellipsis">{{ job.stops[0].detailedServiceTime.generatedTotalTime | bringozTimeConvert: true }}</span>
      </ng-template>
    </div>

  </div>

</div>
